module.exports = __webpack_public_path__ + "img/navigator-white.svg";